import { render, staticRenderFns } from "./QuestionListView.vue?vue&type=template&id=5a38c10a&scoped=true"
import script from "./QuestionListView.vue?vue&type=script&lang=js"
export * from "./QuestionListView.vue?vue&type=script&lang=js"
import style0 from "./QuestionListView.vue?vue&type=style&index=0&id=5a38c10a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38c10a",
  null
  
)

export default component.exports